export default [
    {
        path: 'agendamento',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-agendamento' */
            '@/views/exame-imagem/agendamento/Index'
        ),
        redirect: 'agendamento/index',
        children: [
            {
                name: 'exame-imagem-agendamento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-agendamento' */
                    '@/views/exame-imagem/agendamento/List.vue'
                ),
            },
            {
                name: 'exame-imagem-agendamento-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-agendamento' */
                    '@/views/exame-imagem/agendamento/Form.vue'
                ),
            },
        ],
    },
]